<template>
  <div class="relative">
    <div class="absolute top-0 right-0 z-10" v-if="blackFriday">
      <ontick-discount-badge-component
        :tooltip="'Contém plano(s) em promoção de Black Friday'"
        :text="'BLACK FRIDAY'"
        :blackFriday="blackFriday"
      />
    </div>
    <div
      class="border-ontick-steel-300 dark:border-ontick-graphite-500 flex h-full flex-col overflow-hidden rounded-xl border-2 dark:border-none"
    >
      <div
        class="dark:bg-ontick-graphite-500 relative flex-grow bg-gray-50 px-4 py-3"
      >
        <div
          class="absolute top-0 right-0 flex items-center"
          v-if="data.plans.some((item) => item.active_for_user)"
        >
          <button
            class="text-ontick-graphite-400 hover:text-ontick-carbon-600 relative p-4 transition dark:hover:text-white"
            @click.stop="toggleDropdown"
            content="Ver detalhes"
            v-tippy="{ arrow: true, theme: 'green' }"
          >
            <i v-html="$icons.kebab" class="h-4 w-4"></i>
            <span class="sr-only"> Ver detalhes </span>
          </button>
          <transition
            enter-active-class="transform transition duration-300 ease-custom"
            enter-class="translate-y-1/2 scale-y-0 opacity-0"
            enter-to-class="translate-y-0 scale-y-100 opacity-100"
            leave-active-class="transform transition duration-300 ease-custom"
            leave-class="translate-y-0 scale-y-100 opacity-100"
            leave-to-class="translate-y-1/2 scale-y-0 opacity-0"
          >
            <portal to="modal" class="h-screen w-screen">
              <details-dropdown-component
                v-if="dropdownIsActive"
                @close="dropdownIsActive = false"
                :style="`top: ${dropdownPos.y}px; right: ${dropdownPos.x}px;`"
                :detailsId="
                  data.plans.find((item) => item.active_for_user).extension_id
                "
                :owner="data.extension_owner"
                :isActive="data.plans.some((item) => item.active_for_user)"
                @subscription="$emit('subscription')"
                :price="
                  data.plans.some((item) => item.active_for_user)
                    .extension_price
                "
              />
            </portal>
          </transition>
        </div>
        <div class="flex flex-col space-y-2">
          <img
            :src="logo || data.partner_badge"
            :alt="data.partner_name"
            class="bg-ontick-steel-400 h-12 w-12 rounded-lg p-2 dark:bg-transparent dark:p-0"
          />

          <span class="font-bold">
            {{ isExtension ? data.extension_name : data.partner_name }}
          </span>
          <div class="group">
            <p class="line-clamp-6 text-sm">
              {{ isExtension ? data.extension_desc : data.partner_description }}
            </p>
            <button
              @click="modalIsActive = true"
              class="dark:to-ontick-graphite-500 absolute bottom-0 left-0 hidden w-full items-end justify-center bg-gradient-to-b from-transparent to-gray-50 pb-4 pt-24 transition-all ease-in-out group-hover:flex"
            >
              <span class="text-ontick-blue-600 text-sm font-semibold"
                >Ver mais</span
              >
            </button>
          </div>
        </div>
      </div>
      <div
        class="bg-ontick-steel-100 dark:bg-ontick-steel-600 flex items-center justify-end py-3"
      >
        <div class="relative flex w-full items-center space-x-4 px-4">
          <div
            class="flex flex-1 flex-col justify-between space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4"
          >
            <div
              class="flex -translate-x-3 transform items-center justify-center space-x-2 text-sm"
            >
              <div
                class="flex items-center space-x-1"
                v-if="!!data.partner_yellow_medals"
                :content="`Número de semanas com pelo menos uma estratégia no Ranking.`"
                v-tippy="{ arrow: true, theme: 'green' }"
              >
                <i
                  v-html="$icons.ranking_crown"
                  class="translate-x-1 scale-75 transform"
                ></i>
                <span>
                  {{ data.partner_yellow_medals }}
                </span>
              </div>
            </div>
            <div class="flex w-full items-center space-x-4 sm:w-auto">
              <ontick-button
                @click.native="$emit('action', data.partner_name)"
                customClass="text-gray-300 bg-ontick-blue-700 dark:bg-ontick-blue-900 disabled:bg-transparent dark:disabled:bg-transparent disabled:border disabled:border-ontick-green-900 disabled:text-ontick-green-900 dark:disabled:text-ontick-green-600 w-full sm:w-auto"
                class="space-x-2 text-sm"
                size="small"
              >
                <!-- <span v-if="multiple"> Ver mais </span>
              <span v-else> Ver detalhes </span> -->
                <span> Detalhes </span>
              </ontick-button>
              <!-- <div
                class="flex items-center"
                v-if="data.plans.some((item) => item.active_for_user)"
              >
                <button
                  class="text-ontick-graphite-400 hover:text-ontick-carbon-600 relative transition dark:hover:text-white"
                  @click.stop="dropdownIsActive = !dropdownIsActive"
                  content="Ver detalhes"
                  v-tippy="{ arrow: true, theme: 'green' }"
                >
                  <i v-html="$icons.kebab" class="h-4 w-4"></i>
                  <span class="sr-only"> Ver detalhes </span>
                </button>
                <transition
                  enter-active-class="transform transition duration-300 ease-custom"
                  enter-class="translate-y-1/2 scale-y-0 opacity-0"
                  enter-to-class="translate-y-0 scale-y-100 opacity-100"
                  leave-active-class="transform transition duration-300 ease-custom"
                  leave-class="translate-y-0 scale-y-100 opacity-100"
                  leave-to-class="translate-y-1/2 scale-y-0 opacity-0"
                >
                  <details-dropdown-component
                    v-if="dropdownIsActive"
                    @close="dropdownIsActive = false"
                    class="bottom-12 right-0 z-10"
                    :detailsId="
                      data.plans.find((item) => item.active_for_user)
                        .extension_id
                    "
                    :owner="data.extension_owner"
                    :isActive="data.plans.some((item) => item.active_for_user)"
                    @subscription="$emit('subscription')"
                    :price="
                      data.plans.some((item) => item.active_for_user)
                        .extension_price
                    "
                  />
                </transition>
              </div> -->
            </div>
          </div>
          <!-- <button
            class="text-ontick-graphite-400 hover:text-ontick-carbon-600 relative transition dark:hover:text-white"
            @click.stop="dropdownIsActive = !dropdownIsActive"
            content="Ver detalhes"
            v-tippy="{ arrow: true, theme: 'green' }"
            v-if="data.plans.some((item) => item.active_for_user)"
          >
            <i v-html="$icons.kebab" class="h-4 w-4"></i>
            <span class="sr-only"> Ver detalhes </span>
          </button>
          <transition
            enter-active-class="transform transition duration-300 ease-custom"
            enter-class="translate-y-1/2 scale-y-0 opacity-0"
            enter-to-class="translate-y-0 scale-y-100 opacity-100"
            leave-active-class="transform transition duration-300 ease-custom"
            leave-class="translate-y-0 scale-y-100 opacity-100"
            leave-to-class="translate-y-1/2 scale-y-0 opacity-0"
          >
            <details-dropdown-component
              v-if="dropdownIsActive"
              @close="dropdownIsActive = false"
              class="bottom-12 right-0 z-10"
              :detailsId="
                data.plans.find((item) => item.active_for_user).extension_id
              "
              :owner="data.extension_owner"
              :isActive="data.plans.some((item) => item.active_for_user)"
              @subscription="$emit('subscription')"
              :price="
                data.plans.some((item) => item.active_for_user).extension_price
              "
            />
          </transition> -->
        </div>
      </div>
      <portal to="modal">
        <ontick-modal
          :open="modalIsActive"
          @close="modalIsActive = false"
          size="small"
        >
          <div class="flex flex-col space-y-4">
            <div class="flex flex-col space-y-2">
              <img
                :src="data.partner_badge"
                :alt="data.partner_name"
                class="bg-ontick-steel-400 h-12 w-12 rounded-lg p-2 dark:bg-transparent dark:p-0"
              />

              <span class="font-bold"> {{ data.partner_name }} </span>
              <p class="cursor-pointer text-sm">
                {{ data.partner_description }}
              </p>
            </div>
            <ontick-button
              @click.native="openFromModal"
              customClass="text-gray-300 bg-ontick-blue-700 dark:bg-ontick-blue-900 disabled:bg-transparent dark:disabled:bg-transparent disabled:border disabled:border-ontick-green-900 disabled:text-ontick-green-900 dark:disabled:text-ontick-green-600"
              class="mr-4 space-x-2 text-sm"
              size="small"
            >
              <span v-if="multiple"> Ver mais </span>
              <span v-else> Ver detalhes </span>
            </ontick-button>
          </div>
        </ontick-modal>
      </portal>
    </div>
  </div>
</template>

<script>
import OntickDiscountBadgeComponent from "../../../../shared/components/basic/ontick-discount-badge.component.vue";
import DetailsDropdownComponent from "../extension/details-dropdown.component.vue";

export default {
  components: {
    DetailsDropdownComponent,
    OntickDiscountBadgeComponent,
  },

  props: {
    data: {
      type: Object,
    },
    multiple: {
      type: Boolean,
    },
    isExtension: {
      type: Boolean,
      default: false,
    },
    blackFriday: {
      type: Boolean,
    },
    logo: {
      type: String,
    },
  },

  data() {
    return {
      modalIsActive: false,
      dropdownIsActive: false,
      dropdownPos: {
        x: 0,
        y: 0,
      },
    };
  },

  methods: {
    toggleDropdown(event) {
      this.dropdownPos.x = event.view.innerWidth - event.x;
      this.dropdownPos.y = event.y;
      this.dropdownIsActive = !this.dropdownIsActive;
    },
    openFromModal() {
      this.modalIsActive = false;
      this.$emit("action", this.data.extension_group);
    },
  },
};
</script>

<style lang="scss" scoped></style>
